import { useState } from "react";
import SectionHeading from "@/components/feature/SectionHeading";
import { faqs } from "@/mocks/gua";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[380px_1fr]">
          <SectionHeading
            eyebrow="常见问题"
            title="刚来的人通常会先问这些"
            desc="关于本站收录范围、补档方式和合集维护机制，这里先给你一个清楚的答案。"
          />

          <div className="flex flex-col gap-3">
            {faqs.map((item, idx) => {
              const isOpen = open === idx;
              return (
                <div
                  key={item.q}
                  className={`rounded-xl border transition-colors ${
                    isOpen
                      ? "border-primary-300 bg-background-50"
                      : "border-background-200 bg-background-50"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : idx)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="text-sm font-medium text-foreground-950 md:text-base">
                      {item.q}
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                        isOpen
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                  {isOpen && (
                    <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}